import { Component, Prop, h, Host, Element, Listen } from '@stencil/core';

@Component({
  tag: 'pn-titletag',
  styleUrl: 'pn-titletag.scss',
})
export class PnTiletag {
  /** Icon of the tag */
  @Prop() icon: string = null;

  /** Icon of the tag */
  @Prop({ mutable: true, reflect: true }) color: string = 'green700';

  @Element() hostElement: HTMLElement;

  render() {
    return (
      <Host>
        <slot />
        {this.icon ? <pn-icon icon={this.icon} small="false" color={this.color}></pn-icon> : null}
      </Host>
    );
  }
}
